export default __webpack_public_path__ + "static/media/service.828cee50.svg";